import React from 'react';

interface AstuteTopicPageBreadcrumbProps {
    currentRoot: string;
    categoryPath: string;
    subCategoryPath: string;
    topicResponse: any;
}
export const AstuteTopicPageBreadcrumb = (
    props: AstuteTopicPageBreadcrumbProps
) => {
    return (
        <>
            <a
                className="breadcrumb-link"
                href={`${props.currentRoot}${props.categoryPath}`}
            >
                <span>{props.topicResponse?.data?.categoryName}</span>
            </a>
            <span className="back-slash">{'>'}</span>
            <a
                className="breadcrumb-link"
                href={`${props.currentRoot}${props.subCategoryPath}`}
            >
                <span>{props.topicResponse?.data?.subCategoryName}</span>
            </a>
            <span className="back-slash">{'>'}</span>
        </>
    );
};
